import { z } from 'zod';
/**
 * The entitlements API, fixed by the Interface Contract. Not open to change.
 *
 * Note the resource types use `panel` and `section` rather than the platform
 * spec's `instrument_family` and `instrument_panel` — the contract wins for
 * interfaces, and every other document agrees with it.
 * See docs/CONTRACT-NOTES.md item 1.
 */
export const ResourceType = z.enum([
    'show',
    'audition',
    'panel',
    'section',
    'submission',
    'retreat',
    'content_package',
]);
export const Relation = z.enum([
    'manager',
    'conductor',
    'judge',
    'applicant',
    'participant',
    'owner',
    'conflicted',
    'subscriber',
    // derived, never written as a tuple
    'can_score',
    'can_view',
    'can_approve',
]);
export const GrantSource = z.enum(['stripe', 'staff', 'app', 'system']);
export const CheckRequest = z.object({
    userId: z.string().min(1),
    relation: Relation,
    resourceType: ResourceType,
    resourceId: z.string().min(1),
    /** "high" forces a fresh check, bypassing OpenFGA's caches. */
    consistency: z.enum(['high']).optional(),
});
export const CheckResponse = z.object({ allowed: z.boolean(), reason: z.string() });
/** Up to 100 per call, per the contract. */
export const BatchCheckRequest = z.object({ checks: z.array(CheckRequest).min(1).max(100) });
export const BatchCheckResponse = z.object({ results: z.array(CheckResponse) });
export const GrantRequest = z
    .object({
    userId: z.string().min(1).optional(),
    email: z.string().email().optional(),
    relation: Relation,
    resourceType: ResourceType,
    resourceId: z.string().min(1),
    source: GrantSource,
    sourceRef: z.string(),
    startsAt: z.string().datetime().optional(),
    endsAt: z.string().datetime().optional(),
})
    .refine((v) => Boolean(v.userId) !== Boolean(v.email), {
    message: 'Provide exactly one of userId or email',
});
/** A grant by email with no verified account comes back as "pending". */
export const GrantResponse = z.object({
    grantId: z.string(),
    status: z.enum(['active', 'pending', 'revoked']),
});
export const RevokeRequest = z.object({ reason: z.string().min(1) });
export const MembersResponse = z.object({
    members: z.array(z.object({ userId: z.string(), relation: Relation, since: z.string().datetime() })),
});
export const ListResourcesResponse = z.object({ resourceIds: z.array(z.string()) });
export const CreateResourceRequest = z.object({
    type: ResourceType,
    id: z.string().min(1),
    parentType: ResourceType.optional(),
    parentId: z.string().optional(),
    name: z.string().min(1),
});
//# sourceMappingURL=entitlements.js.map